import { getRgObjectsOfType as n, RG_TYPE as u } from "@project-rouge/rg-core";
const m = (e) => {
  const t = n(e, u.Building).map((i) => l(i));
  return Math.max(0, ...t);
};
function l(e) {
  return e.data.levels.filter((t) => t.isPodium).length;
}
export {
  m as getPodiumLevelCount
};
//# sourceMappingURL=index43.js.map
